<div class="d-flex flex-row flex-wrap" *ngIf="charts">
  <div class="d-flex flex-row chart-container" *ngFor="let chart of charts; let i = index">
    <achoo-gauge-circle-chart [width]="200"
                              [height]="calculateHeight()"
                              [chartTitle]="chart.name"
                              [platformName]="chart.platformName"
                              [chartData]="[getChartContent(chart, i % 4)]"
                              [showInLegend]="false"
                              [titlePosition]="titlePosition"
                              [spacingBottom]="calculateSpacingBottom()"
                              [spacingTop]="calculateSpacingTop()"
                              [description]="chart.description"
                              [tooltipInfo]="statusTooltip">
      <div *ngIf="i===0 && chartHeader" class="list-gauge-charts-header">
        <span>{{chartHeader}}</span>
        <achoo-icon-tooltip *ngIf="titleTooltip" [tooltipMsg]="titleTooltip"></achoo-icon-tooltip>
      </div>
      <achoo-gauge-circle-chart-content [reachValue]="chart.contentPieChart.reach.value"
                                        [reachStatus]="chart.contentPieChart.reach.status"
                                        [reachLabel]="getReachLabel()"
                                        [isTitleOnTop]="titlePosition === 'top'"
                                        [tooltipInfo]="chart.contentPieChart.reach.tooltipInfo"
                                        [isChannelFollower]="isChannelFollower"
                                        [reachPercent]="chart.contentPieChart.reach.percent">
      </achoo-gauge-circle-chart-content>
    </achoo-gauge-circle-chart>
    <div *ngIf="hasLeftBorderLine(i + 1)" class="gauge-seperate-line"></div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/core/list-gauge-circle-chart/list-gauge-circle-chart.component.html